import api from "../api";
import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Grid, TextField, Button, InputAdornment, IconButton, Typography }
    from "@mui/material";
import AuthCard from "./authCard";
import { Visibility, VisibilityOff } from '@mui/icons-material';


function PasswordUpdate() {
  const { token } = useParams(); // Récupérer le token depuis l'URL
  const navigate = useNavigate();
  
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [passwordMatch, setPasswordMatch] = useState(true);

  const handleClickShowPassword = () => {
      setShowPassword(!showPassword);
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    
    if (newPassword !== confirmPassword) {
      setPasswordMatch(false);
      setMessage("Les mots de passe ne correspondent pas.");
      return;
    }
    try {
      const response = await api.post("/events/updatePassword", {
        resetToken: token,
        newPassword: newPassword,
      });

      if (response.data.message) {
        setMessage("Mot de passe mis à jour avec succès. Redirection vers la connexion...");
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      }
    } catch (error) {
      setMessage("Erreur lors de la mise à jour du mot de passe.");
      console.error(error);
    }
  };

    return (
        <AuthCard>
            <Typography variant="h5" align="center" gutterBottom sx={{ mb: 3 }}>
                Veuillez saisir un nouveau mot de passe
            </Typography>
            <form onSubmit={handleUpdatePassword}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                            name="New Password"
                            type={showPassword ? "text" : "password"}
                            label="Nouveau mot de passe"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            fullWidth
                            required
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                        >
                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            name="ConfirmPassword"
                            type={showPassword ? "text" : "password"}
                            label="Confirmer le mot de passe"
                            value={confirmPassword}
                            fullWidth
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                        >
                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button type="submit" variant="contained" fullWidth>
                            Mettre à jour le mot de passe
                        </Button>
                    </Grid>
                </Grid>
            </form>
            {message && (
                <Typography align="center" color="text.secondary" sx={{ mt: 2 }}>
                    {message}
                </Typography>
            )}
        </AuthCard>
    );
}

export default PasswordUpdate;